import React from 'react'
import Cards from '../Components/Cards'


const About = () => {
  
  return (
    <div >
     <Cards />
     </div>
  )
}
export default About
